import { dashboardBreadcrumbs } from "../features/Dashboard/dashboard-breadcrumbs";
import { LearningCenter } from "@features/LearningCenter";
import { PageLayout } from "../shared/layouts/PageLayout";

const breadcrumbs = {
  current: dashboardBreadcrumbs.learningCenter,
  previous: [dashboardBreadcrumbs.accountSettings],
};

export function LearningCenterPage() {
  return (
    <PageLayout breadcrumbs={breadcrumbs}>
      <LearningCenter />
    </PageLayout>
  );
}
